import React from "react";
import { useNavigate } from 'react-router-dom';
export default function SucessfullySubmited({ setActivitySubDetail }) {
  const navigate = useNavigate();
  return (
    <div className="ContainerSubmitedSucess ">
      <div className="SubContainerSubmitedSucess">
        <div className="d-flex justify-content-center align-items-center">
          <img src="/HwImg/sucessIcon.png" alt="" />
        </div>
        <div className="d-flex justify-content-center align-items-center mt-4 sucessMsg1">
          You Have successfully submitted the activity.
        </div>
        <div className="d-flex justify-content-center align-items-center mt-2 sucessMsg2">
          Once teacher evaluates, you will be notified
        </div>
        <div className="d-flex justify-content-center align-items-center mt-3">
          <button
            className="okayBtnsucess"
            onClick={() => navigate("/Activity")}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
